import { CloseCircleOutlined, DeleteFilled, EyeOutlined, LineChartOutlined, MailOutlined, MinusCircleOutlined, NotificationOutlined, PlusCircleOutlined, PlusOutlined, SearchOutlined, ShopOutlined, StarOutlined, UserAddOutlined, UserOutlined } from '@ant-design/icons';
import { Badge, Button, Card, Input, message, Spin, Switch, Table, Tag, Tooltip } from 'antd';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FilterDropdownProps } from 'antd/lib/table/interface';
import { DrawerContext } from '../../../store/DrawerContext/DrawerContext';
import { useFetch } from '../../../hooks/useFetch/useFetch';
import { authFetch } from '../../../common/request/authFetch';
import { ButtonLZ } from '../../components/design/Buttons/ButtonLZ';
import TableLZM from '../../components/design/table/TableLZM';
import '../pages.scss'
import { authRequest } from '../../../common/request/authRequest';
import { GuestAssignModal } from './guests/GuestAssignModal';
import { useAuth } from '../../../store/AuthContext/AuthContext';
import { PageTitle } from '../common/PageTitle';
import { EmptyStateBox } from '../../components/design/EmptyStateBox/EmptyStateBox';

export const GuestPermissions = () => {

  const { profile, projectGroup} = useAuth();

  const [groupSelected, setGroupSelected] = useState(null);  
  const [updateData, setUpdateData] = useState(false);  
  const [groups, setGroups] = useState();    

  async function changeStatus(groupId: string) {
    await authFetch(`${process.env.REACT_APP_API}/config/projects/${projectGroup.project}/${groupId}`, { method: 'PATCH' }).then(()=>{
        setUpdateData(!updateData)
        //window.document.location.reload();
    });
  }

  const { isLoading } = useFetch(`${process.env.REACT_APP_API}/config/projects/${projectGroup.project}`,
		{},
		[updateData],
		(data) => {			
			setGroups(data);		      	      
		}
	);
  
  const deassignUser = async (groupId: string, userId: string) => {
		    
    const data = {
			group: groupId,
      project: projectGroup.project,	
			guestEmail: userId
		};		

		await authRequest(`${process.env.REACT_APP_API}/config/guest/deassign`, { method: 'PATCH', data: data })
      .then((data) => {
      setUpdateData(!updateData);
      message.success('Usuario desvinculado correctamente');
    }).catch((error) => {
      message.error('Error imprevisto');
    });
	};	

  const columns: any = [ 
  {
    title: 'Grupo',
    key: 'name',
    dataIndex: 'name',
    width:'400px',
    render: (text: string, record: any) => {				
      return  <Card bodyStyle={{background:record.group.active ? 'ivory': 'transparent', borderRadius: '15px', color: record.group.active ? 'black' : 'slategrey', border: 'solid, .5px, slategrey'}}>
                <div style={{display:'flex', justifyContent:'space-between'}}>
                  <Switch size='small' checked={record.group.active} checkedChildren="Activo" unCheckedChildren="Desactivado" onChange={() => {changeStatus(record.group.name)}}/>
                  <b>{record.group.accountName}</b>                
                </div>
                <div style={{color:record.group.active ? 'purple' : 'slategrey', display:'flex', justifyContent:'end'}}><i>{GROUPS_NAMES[record.group.type]}</i></div>
              </Card>
    }
  },
  {
    title: 'Invitados',
    key: 'guests',    
    align:'left',
    //sorter: (a: any, b: any) => a.completedRatio.ratio - b.completedRatio.ratio,
    render: (text: string, record: any) => {				
      return  <>
                {record.guests.length == 0 ?
                <EmptyStateBox
                  subtle
                  icon={<UserOutlined />}
                  title="No hay invitados"
                  description="Vincula un usuario a este grupo"
                />
                :
                record.guests.filter((guest: any) => guest !== null && guest !== undefined).map((guest: any) => (
                  <div> 
                    <Tag style={{borderRadius:'5px', margin:'4px'}} color={guest.enabled && guest.editInfo && 'blue'}><div><ShopOutlined/></div></Tag>
                    <Tag style={{borderRadius:'5px', margin:'4px'}} color={guest.enabled && guest.editReviews &&'blue'}><div><StarOutlined/></div></Tag>
                    <Tag style={{borderRadius:'5px', margin:'4px'}} color={guest.enabled && guest.editContent && 'blue'}><div><NotificationOutlined/></div></Tag>                    
                    <b style={{color:guest.enabled?'steelblue':'lightgrey', marginLeft:'80px'}}>
                      {guest.email}
                      <Tooltip title='Desvincular Usuario'>
                           <MinusCircleOutlined disabled={!profile.roles?.includes('ROLE_MODULE_USERS')} style={{ margin: '10px' }} onClick={()=>{deassignUser(record.name, guest.email)}}/>                        
                      </Tooltip>
                    </b>
                  </div>
                ))
              }
      </>
    }
  },
  {
    title: '',    
    width: '100px',
    render: (record: any) => (
      <div style={{display:'flex', justifyContent:'space-between'}}>										        
        <ButtonLZ onClick={()=>{setGroupSelected(record.group)}} size='small' style={{ borderRadius: '20px' }}>    
          <UserAddOutlined disabled={!profile.roles?.includes('ROLE_MODULE_USERS')}/> Vincular usuario
        </ButtonLZ>
      </div>
    )
  }
]
  
  return (
    <>
      <Card className='main-card-content'>
        <PageTitle
          title='Gestión de grupos'
          pageInfo='Activa o desactiva grupos y vincula invitados a los grupos a los que quieras que tengan acceso.'
        />
        {/*isLoading && <div style={{display:'flex', justifyContent:'center'}}><Spin style={{margin:'200px'}}/></div>*/}
        {groups && <TableLZM  columns={columns} dataSource={groups} rowKey={'email'} loading={isLoading} />}        
      </Card>

      {groupSelected && <GuestAssignModal
          group={groupSelected}
          onFinish={() => {
            setGroupSelected(null);
            setUpdateData(!updateData);
          }}
        />}           
    </>
	)
}

export const GROUPS_NAMES: any = {
  "PERSONAL": "Personal",  
  "LOCATION_GROUP": "Grupo de Ubicaciones",  
  "ORGANIZATION": "Organización"   
}

